module.exports = __webpack_public_path__ + "static/media/traffic-planned.bf99b435.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-planned.svg
// module id = 426
// module chunks = 0